(function () {
    if (!document.getElementById('mm-read-more-styles')) {
        const style = document.createElement('style');
        style.id = 'mm-read-more-styles';
        style.textContent = `
            .mm-read-more-wrapper { position: relative; width: 100%; }
            .mm-read-more-text { overflow: hidden; transition: max-height 0.3s ease; }
            .mm-read-more-text.is-collapsed {
                -webkit-mask-image:
                    linear-gradient(to right, black calc(100% - 100px), transparent calc(100% - 75px)),
                    linear-gradient(to bottom, black 50%, transparent 50%);
                mask-image:
                    linear-gradient(to right, black calc(100% - 100px), transparent calc(100% - 75px)),
                    linear-gradient(to bottom, black 50%, transparent 50%);
            }
            .mm-read-more-btn {
                display: none;
                position: absolute;
                bottom: 0;
                right: 0;
                background: none;
                border: none;
                cursor: pointer;
                text-decoration: underline;
                font: inherit;
                color: inherit;
                opacity: 0;
                transition: opacity 0.1s ease;
            }
            .mm-read-more-wrapper.is-expanded .mm-read-more-btn {
                position: static;
                display: block;
                width: fit-content;
                margin: 4px auto 0;
            }
        `;
        document.head.appendChild(style);
    }

    function initReadMore(root) {
        (root || document).querySelectorAll('[data-read-more]:not([data-read-more-init])').forEach(wrapper => {
            wrapper.setAttribute('data-read-more-init', '');

            const text = wrapper.querySelector('.mm-read-more-text');
            const labelOpen = wrapper.dataset.readMoreOpen || (window.readMoreStrings && window.readMoreStrings.open) || 'Lire plus';
            const labelClose = wrapper.dataset.readMoreClose || (window.readMoreStrings && window.readMoreStrings.close) || 'Lire moins';
            const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
            const collapsedHeight = lineHeight * 2;
            const textDuration = 300;
            const fadeDuration = 100;

            if (text.scrollHeight <= collapsedHeight + 2) {
                text.style.maxHeight = '';
                text.style.overflow = '';
                return;
            }

            const btn = document.createElement('button');
            btn.className = 'mm-read-more-btn';
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = '... ' + labelOpen;
            btn.style.display = 'block';
            wrapper.appendChild(btn);

            text.style.maxHeight = collapsedHeight + 'px';
            text.classList.add('is-collapsed');
            setTimeout(() => { btn.style.opacity = '1'; }, 50);

            btn.addEventListener('click', () => {
                const expanded = btn.getAttribute('aria-expanded') === 'true';
                btn.style.opacity = '0';

                setTimeout(() => {
                    if (expanded) {
                        wrapper.classList.remove('is-expanded');
                        text.style.maxHeight = collapsedHeight + 'px';
                        btn.setAttribute('aria-expanded', 'false');
                        btn.textContent = '... ' + labelOpen;
                        text.addEventListener('transitionend', () => {
                            text.classList.add('is-collapsed');
                            btn.style.opacity = '1';
                        }, { once: true });
                    } else {
                        wrapper.classList.add('is-expanded');
                        text.style.maxHeight = text.scrollHeight + 'px';
                        text.classList.remove('is-collapsed');
                        btn.setAttribute('aria-expanded', 'true');
                        btn.textContent = labelClose;
                        setTimeout(() => { btn.style.opacity = '1'; }, textDuration);
                    }
                }, fadeDuration);
            });
        });
    }

    initReadMore();

    // Re-init quand le customizer Shopify recharge une section
    document.addEventListener('shopify:section:load', (e) => {
        // Reset les wrappers de la section rechargée pour permettre la ré-init
        e.target.querySelectorAll('[data-read-more]').forEach(wrapper => {
            wrapper.removeAttribute('data-read-more-init');
            const btn = wrapper.querySelector('.mm-read-more-btn');
            if (btn) btn.remove();
            const text = wrapper.querySelector('.mm-read-more-text');
            if (text) {
                text.style.maxHeight = '';
                text.classList.remove('is-collapsed');
            }
            wrapper.classList.remove('is-expanded');
        });
        initReadMore(e.target);
    });
})();
